import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTimeslotForm from "../../forms/CreateOrUpdateTimeslotForm";

interface CreateTimeslotModalProps {
  open: boolean;
  onClose: () => void;
  userInfo?: any;
  loading: boolean;
  error: string | null;
}

const CreateTimeslotModal: React.FC<CreateTimeslotModalProps> = ({
  open,
  onClose,
  userInfo,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Create New Timeslot"
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateTimeslotForm
      userInfo={userInfo}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default CreateTimeslotModal;
